/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
  Alert,
  Button,
  Form,
  ButtonGroup,
  InputGroup,
  Card,
  Container,
  Dropdown,
  Modal,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { apiURL, deleteApi, fetchApi, postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import EditApproval from "./EditApproval";
import SearchInput from "../../../components/SearchInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { fetchUserData } from '';
import {
  faBackward,
  faCaretDown,
  faSearch,
  faEdit,
  faEye,
  faListUl,
  faMarker,
  faTrash,
  faCheck,
  faReplyAll,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { SearchContext } from "../../HomePage";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import moment from "moment-timezone";
import { Input } from "reactstrap";
import useQuery from "../../../hooks/useQuery";
import CustomButton from "../../../components/CustomButton";
// import { PaymentSchedulePdf } from "../../sub-treasury/pv-collection/PaymentSchedulePdf";
import QRCode from "qrcode";
import PaymentPDF from "../batch-processing/PaymentPDF";
import PaymentSchedulePDF2 from "../batch-processing/PaymentScheduleNew2";

function ApprovalCollectionAgDash({ match, type = null }) {
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  const location = useLocation();
  const isPending = location.pathname.includes("payapp");
  const isCheck = location.pathname.includes("expenditure-control/cheque");
  const isExpediture = location.pathname.includes("expenditure/view");
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif"];
  const [filterText, setFilterText] = useState("");
  const batch_no = useParams().batch_no;
  const [budgetUtilization, setBudgetUtilization] = useState([]);
  const [modal, setModal] = useState(false);
  const [filter, setFilter] = useState(type || "All");
  const [attachmentModalIsOpen, setAttachmentModalIsOpen] = useState(false);
  const [check, setCheck] = useState(false);
  const [selectedApproval, setApprovalNo] = useState("");
  const [returndApproval, retApprovalNo] = useState("");

  const [approvalImageInfo, setApprovalImageInfo] = useState([]);
  const [item, setItem] = useState({});
  const [_delete, setDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dateFrom, setDateFrom] = useState(
    moment().subtract(1, "month").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [approvalTypeFilter, setApprovalTypeFilter] = useState("Recurrent");
  const isDirTreasury = location.pathname.includes("dir-treasury-contro");
  const isExpControl = location.pathname.includes("expenditure/view");
  const toggleDelete = (item) => {
    setItem(item);
    setDelete(!_delete);
  };
  const [showRemark1, setShowRemark1] = useState(false);
  const [showRemark, setShowRemark] = useState(false);
  const [remark, setRemark] = useState("");
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [returnlLoading, setReturnLoading] = useState(false);
  const [returnlMessage, setReturnMessage] = useState(null);
  const [approvalMessage, setApprovalMessage] = useState(null);
  const [userData, setUserData] = useState(null);
  const toggleRemark = () => setShowRemark((p) => !p);
  const toggleRemark1 = () => setShowRemark1((p) => !p);
  const [form, setForm] = useState({ check: "" });
  const handleChanges = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };
  const attachmentModalToggle = () => {
    setAttachmentModalIsOpen((p) => !p);
  };
  const checkModalToggle = () => {
    setCheck((p) => !p);
  };
  // postApi(`post_approval_collection`, {
  //   form: { query_type: isPending ? "pending" : "by_mda", filter },
  //   // status : "Paid",
  //   // batch_no
  // })

  const handleViewClick = async (item) => {
    try {
      const response = await postApi(`post_approval_collection`, {
        form: {
          query_type: "select_by_approval_no",
          approval_no: item.approval_no,
        },
      });

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const userData = await response.json();
      setUserData(userData);

      // Navigate to edit approval route
      history(`${Routes.approval.editApprovalRoute}/${item.approval_no}`);
    } catch (error) {
      console.error("Error Fetching Release Collection Data:", error);
      // Log response data if available
      if (error.response) {
        console.error("Response Data:", await error.response.json());
      }
    }
  };

  const fetchApprovalData = async (approval_no) => {
    try {
      const response = await fetch(
        `post_approval_collection?approval_no=${approval_no}`
      );
      const data = await response.json();
      history.push(`${Routes.approval.editApprovalRoute}/${item.approval_no}`);
      return data;
    } catch (error) {
      throw new Error("Error fetching approval data");
    }
  };

  const viewAttachment = (imageid, approval_no) => {
    setApprovalNo(approval_no);
    fetchApi(`fetch-approval-images?approval_no=${imageid}`).then((resp) => {
      attachmentModalToggle();
      if (resp.results && resp.results.length) {
        setApprovalImageInfo(resp.results);
      } else {
        setApprovalImageInfo({});
      }
    });
  };

  const query = useLocation().search;
  let typeshit = location.pathname.includes("approval-collection/ag-dashboard");
  let typeshit2 = location.pathname.includes("/approval-collection/ag-payment");
  const getApprovalCollection = useCallback(() => {
    setLoading(true);

    const queryType = isDirTreasury
      ? "ag_approved_pvs"
      : isExpControl
      ? "exp_control_release"
      : isCheck
      ? "exp_control_release"
      : typeshit2
      ? "payments"
      : typeshit
      ? "ag_pending_releases"
      : "";

    postApi(`post_approval_collection`, {
      form: {
        query_type: queryType,
        filter: "Pending",
        projectType: "Treasury Approved",
        approval_status: "Internal Audit Approved",
      },
    })
      .then((data) => {
        if (data.result) {
          const arr = data.result.map((item) => ({ ...item, isOpen: false }));
          // alert(JSON.stringify(arr));
          setBudgetUtilization(arr);
        }
      })
      .catch((err) => {
        console.error("Error fetching approval collection:", err);
        toast.error("Failed to fetch approvals");
      })
      .finally(() => setLoading(false));
  }, [typeshit2, typeshit, isCheck, isDirTreasury, isExpControl]);

  useEffect(() => {
    getApprovalCollection();
  }, [getApprovalCollection]);

  useEffect(() => {
    getApprovalCollection();
  }, [getApprovalCollection, query]);

  const handleFilter = () => {
    return budgetUtilization;
  };

  // useEffect(() => {
  //   handleFilter();
  // }, [dateFrom, dateTo]);

  const filteredList = handleFilter();

  const list = filteredList.filter(
    (item) =>
      (item.approval_no.includes(filterText) ||
        item.mda_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.amount.toString().includes(filterText)) &&
      item.approval_type === approvalTypeFilter
  );

  const updateReturnApproval = (approval_no, status) => {
    setReturnLoading(true);
    postApi("return-approval", {
      remarks: remark,
      status,
      approval_no,
      userId: user.username,
    })
      .then((resp) => {
        setReturnLoading(false);
        if (resp && resp.success) {
          setReturnMessage("Return Successfully");
          setTimeout(() => {
            toggleRemark();
            getApprovalCollection();
          }, 1000);
        }
      })
      .catch((err) => {
        setReturnLoading(false);
        toast.error("An error occured, please try again later");
        console.log(err);
      });
  };

  const updateApproval = async (approval_no, status) => {
    setApprovalLoading(true);
    try {
      if (selectedReleases.length > 0) {
        for (const release of selectedReleases) {
          await postApi("update-approval", {
            query_type: isDirTreasury
              ? "update_new"
              : isCheck
              ? "update_cheque"
              : "update_ag_status",
            status: isDirTreasury
              ? "Treasury Approved"
              : isCheck
              ? "Approval Processed"
              : status === "Return Processed"
              ? status
              : "AG Approved",
            remarks: form.cheque,
            approval_no: release.approval_no,
            userId: user.username,
            mda_name: user.mda_name,
          });
        }
        setApprovalMessage("All selected releases approved successfully");
      } else {
        // Handle single approval case
        await postApi("update-approval", {
          query_type: "update_ag_status",
          remarks: remark,
          status: "AG Approved",
          approval_no,
          userId: user.username,
          mda_name: user.mda_name,
        });
        setApprovalMessage(
          status === "Return Processed"
            ? "Returned Releases Successfully"
            : "Approved Successfully"
        );
      }

      setTimeout(() => {
        setPdf(true);
        toast.success("Approved Successfully");
        if (isCheck) {
          //  checkModalToggle();
        } else {
          getApprovalCollection();
        }
        setSelectedReleases([]); // Clear selections after processing
      }, 1000);
    } catch (err) {
      toast.error("An error occurred, please try again later");
      console.log(err);
    } finally {
      setApprovalLoading(false);
    }
  };
  const [approval, setApproval] = useState();
  const [selectedReleases, setSelectedReleases] = useState([]);
  const onCheckAll = () => {
    if (selectedReleases.length) {
      setSelectedReleases([]);
    } else {
      setSelectedReleases(budgetUtilization);
    }
  };

  const onCheck = (item) => {
    let newList = [];
    let itemFound = selectedReleases.find((s) => s.id === item.id);
    if (itemFound) {
      newList = selectedReleases.filter((s) => s.id !== item.id);
    } else {
      newList = [...selectedReleases, item];
    }
    setSelectedReleases(newList);
  };
  const [expandedRows, setExpandedRows] = useState([]);

  const totalAmount = selectedReleases.reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );
  const toggleRowExpansion = (id) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter((rowId) => rowId !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  };
  const [pdf, setPdf] = useState(false);
  const fields = [
    {
      title: "Action",
      headerComponent: () => (
        <div>
          <input
            type="checkbox"
            checked={selectedReleases.length === budgetUtilization.length}
            onChange={() => onCheckAll()}
          />
        </div>
      ),
      custom: true,
      component: (item, index) => (
        <div>
          <input
            type="checkbox"
            checked={selectedReleases.findIndex((s) => s.id === item.id) !== -1}
            onChange={() => onCheck(item)}
          />
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   custom: true,
    //   component: (item, index) =>
    //     item.approval_status === "No Budget" ? null : (
    //       <div>
    //         {
    //           isDirTreasury || isExpControl?
    //           <Button onClick={() =>{
    //           history(
    //             `${Routes.approval.editApprovalRouteDirTreasury}/${item.approval_no}/${isExpControl?"exp_control":isDirTreasury?"drtreasury":"ag"}`,

    //           );

    //         }
    //         }>Views</Button>:isCheck?<Button onClick={()=>{setApproval(item.approval_no);checkModalToggle()}}>Process</Button>:
    //         <Button onClick={() =>
    //              history(
    //             `${Routes.approval.editApprovalRouteAg}/${item.approval_no}`
    //           )
    //         }>Views</Button>
    //         }

    //       </div>
    //       // <Dropdown>
    //       //   <Dropdown.Toggle
    //       //     as={Button}
    //       //     variant="primary"
    //       //     className="me-2 bg-success"
    //       //   >
    //       //     <span>Action</span>
    //       //     <FontAwesomeIcon icon={faCaretDown} className="ms-2" />
    //       //   </Dropdown.Toggle>
    //       //   <Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-2">
    //       //     {/* {item.approval_status === "Approval Released" ? (
    //       //       <Dropdown.Item
    //       //         onClick={() => {
    //       //           setApprovalNo(item.approval_no);
    //       //           toggleRemark();
    //       //         }}
    //       //         // onClick={() => viewAttachment(item.imageId, item.approval_no)}
    //       //       >
    //       //         <FontAwesomeIcon icon={faEdit} className="me-2" /> Approve
    //       //       </Dropdown.Item>
    //       //     ) : null} */}
    //       //     {/* <Dropdown.Item onClick={handleViewClick}>
    //       //     <FontAwesomeIcon icon={faEye} className="me-2" /> View
    //       //     {userData && <EditApproval userData={userData} />}
    //       //   </Dropdown.Item> */}
    //       //     <Dropdown.Item
    //       //       onClick={() =>
    //       //         history(
    //       //           `${Routes.approval.editApprovalRouteAg}/${item.approval_no}`
    //       //         )
    //       //       }
    //       //     >
    //       //       <FontAwesomeIcon icon={faEye} className="me-2" /> View
    //       //     </Dropdown.Item>
    //       //     {/* <Dropdown.Item onClick={() => toggleDelete(item)}>
    //       //     <FontAwesomeIcon icon={faTrash} className="me-2" /> Delete
    //       //   </Dropdown.Item> */}
    //       //     {/* <Dropdown.Item
    //       //       onClick={() => {
    //       //         setApprovalNo(item.approval_no);
    //       //         toggleRemark1();
    //       //       }}
    //       //     >
    //       //       <FontAwesomeIcon icon={faBackward} className="me-2" /> Return
    //       //     </Dropdown.Item> */}
    //       //   </Dropdown.Menu>
    //       // </Dropdown>
    //     ),
    // },
    // {
    //   title: 'S/N',
    //   custom: true,
    //   component: (item, index) => <div>{index + 1}</div>,
    // },
    {
      title: "Approval Date",
      value: "approval_date",
    },
    {
      title: "Approval No",
      value: "approval_no",
    },
    {
      title: "Batch No",
      custom: true,
      component: (item, index) => <div>{item.no_of_release}</div>,
    },

    {
      title: "MDA Name",
      value: "mda_name",
    },
    // {
    //   title: "Economic Code",
    //   value: "economic_code",
    // },
    // {
    //   title: "Collection Date",
    //   value: "collection_date",
    // },

    {
      title: "Purpose",
      custom: true,
      component: (item) => {
        const isExpanded = expandedRows.includes(item.id);
        const text = item.narration || "";
        const shouldShowButton = text.length > 50;

        return (
          <div>
            {isExpanded ? text : text.slice(0, 50)}
            {shouldShowButton && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleRowExpansion(item.id);
                }}
                className="btn btn-link btn-sm"
              >
                {isExpanded ? "Show Less" : "...Show More"}
              </button>
            )}
          </div>
        );
      },
    },

    {
      title: "Approval Type",
      value: "approval_type",
    },

    // {
    //   title: "Status",
    //   value: "approval_status",
    // },
    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];

  const fields2 = [
    {
      title: "Action",
      headerComponent: () => (
        <div>
          <input
            type="checkbox"
            checked={selectedReleases.length === finalList.length}
            onChange={() => onCheckAll()}
          />
        </div>
      ),
      custom: true,
      component: (item, index) => (
        <div>
          <input
            type="checkbox"
            checked={selectedReleases.findIndex((s) => s.id === item.id) !== -1}
            onChange={() => onCheck(item)}
          />
        </div>
      ),
    },
    // {
    //   title: 'S/N',
    //   custom: true,
    //   component: (item, index) => <div>{index + 1}</div>,
    // },
    {
      title: "Approval No",
      value: "approval_no",
    },
    {
      title: "Batch No",
      custom: true,
      component: (item, index) => <div>{item.no_of_release}</div>,
    },
    {
      title: "MDA Name",
      value: "mda_name",
    },
    // {
    //   title: "Economic Code",
    //   value: "economic_code",
    // },
    // {
    //   title: "Collection Date",
    //   value: "collection_date",
    // },
    {
      title: "Approval Date",
      value: "approval_date",
    },

    {
      title: "Approval Type",
      value: "approval_type",
    },
    {
      title: "Purpose",
      value: "narration",
    },
    // {
    //   title: "Status",
    //   value: "approval_status",
    // },
    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];
  const modalFields = [
    {
      title: "Approval No",
      value: "approval_no",
    },
    {
      title: "Release Date",
      value: "approval_date",
    },
    {
      title: "MDA Name",
      value: "mda_name",
    },

    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];

  // const getRowStyle = (row) => {
  //   switch (row.approval_status) {
  //     case "Approval Released":
  //       return { backgroundColor: "orange" };
  //     case "Return Released":
  //       return { backgroundColor: "orange" };
  //     case "Approval Processed":
  //       return { backgroundColor: "lightblue" };
  //     case "Return Processed":
  //       return { backgroundColor: "lightblue" };
  //     case "Approval Approved":
  //       return { backgroundColor: "lightgreen" };
  //     case "Return Approved":
  //       return { backgroundColor: "lightgreen" };
  //     case "Approval Queried":
  //       return { backgroundColor: "yellow" };
  //     case "Return Queried":
  //       return { backgroundColor: "yellow" };
  //     case "Payment Schedule":
  //       return { backgroundColor: "green" };
  //     case "Return Schedule":
  //       return { backgroundColor: "green" };
  //     default:
  //       return {};
  //   }
  // };
  // const [remark, setRemark] = useState("");
  const [returnModal, setReturnModal] = useState(false);

  // const toggleRemark = () => setShowRemark((p) => !p);
  const toggleReturnModal = () => setReturnModal((p) => !p);
  //  const updateApproval = (approval_no, status) => {
  //   // alert("HERE!!!")
  //   // const approvalIsPending = form?.approval_status === "Approval Released";
  //   // const approvalIsReceived = form?.approval_status==="Approval Received"
  //   console.log("form?.approval_status", form?.approval_status);
  //   console.log(
  //     "user.mda_name",
  //     user.mda_name,
  //     user.mda_name === "Office of the Accountant-General"
  //   );
  //   setApprovalLoading(true);
  //   if (status.includes("Return")) {
  //     postApi("update-approval", {
  //       remarks: remark,
  //       status: form?.approval_status.includes("Approval Released")
  //         ? "Approval Received - Returned"
  //         : form?.approval_status.includes("Approval Received")
  //         ? "Approval Reviewed - Returned"
  //         : form?.approval_status.includes("Approval Reviewed") ||
  //           form?.approval_status.includes("approval Reviewed")
  //         ? user.mda_name === "Office of the Accountant-General"
  //           ? "Approved by Director Exp. Cont. - Returned"
  //           : "Approval Released - Returned"
  //         : "Approval Released - Returned",
  //       approval_no,
  //       userId: user.username,
  //       mda_name: user ? user.mda_name : "",
  //     })
  //       .then((resp) => {
  //         setApprovalLoading(false);
  //         if (resp && resp.success) {
  //           setApprovalMessage("Returned Successfully");
  //           setTimeout(() => {
  //             //   toggleRemark();
  //             // getApprovalCollection();
  //             if (form?.approval_status.includes("Approval Released")) {
  //               navigate(Routes.approval.pendingApproval);
  //             } else if (form?.approval_status.includes("Approval Received")) {
  //               navigate(Routes.approval.reviewReleases);
  //             } else if (
  //               form?.approval_status.includes("Approval Reviewed") ||
  //               form?.approval_status.includes("approval Reviewed")
  //             ) {
  //               navigate(Routes.approval.approvalReleases);
  //             }
  //           }, 1000);
  //         }
  //       })
  //       .catch((err) => {
  //         setApprovalLoading(false);
  //         toast.error("An error occured, please try again later");
  //         console.log(err);
  //       });
  //   } else {
  //     postApi("update-approval", {
  //       remarks: remark,
  //       status:
  //         form?.approval_status === "Approval Released"
  //           ? "Approval Received"
  //           : form?.approval_status === "Approval Received"
  //           ? "Approval Reviewed"
  //           : form?.approval_status === "Approval Reviewed" ||
  //             form?.approval_status === "approval Reviewed"
  //           ? user.mda_name === "Office of the Accountant-General"
  //             ? "Approved by Director Exp. Cont."
  //             : "Approval Processed"
  //           : "Approval Processed",
  //       approval_no,
  //       userId: user.username,
  //       mda_name: user ? user.mda_name : "",
  //     })
  //       .then((resp) => {
  //         setApprovalLoading(false);
  //         if (resp && resp.success) {
  //           setApprovalMessage("Approved Successfully");
  //           setTimeout(() => {
  //             toggleRemark();
  //             // getApprovalCollection();
  //             if (form?.approval_status === "Approval Released") {
  //               navigate(Routes.approval.pendingApproval);
  //             } else if (form?.approval_status === "Approval Received") {
  //               navigate(Routes.approval.reviewReleases);
  //             } else if (
  //               form?.approval_status === "Approval Reviewed" ||
  //               form?.approval_status === "approval Reviewed"
  //             ) {
  //               navigate(Routes.approval.approvalReleases);
  //             } else if (
  //               form?.approval_status === "Approved by Director Exp. Cont."
  //             ) {
  //               navigate(Routes.approval.adExpContrReleases);
  //             }
  //           }, 1000);
  //         }
  //       })
  //       .catch((err) => {
  //         setApprovalLoading(false);
  //         toast.error("An error occured, please try again later");
  //         console.log(err);
  //       });
  //   }
  // };

  const handleDelete = () => {
    setLoading(true);
    deleteApi(`delete-approve-collection`, item)
      .then((res) => {
        toast.success("Deleted Successfully");
        setLoading(false);
        getApprovalCollection();
        toggleDelete({});
      })
      .catch((err) => {
        toast.error(`error occured ${JSON.stringify(err)}`);
        setLoading(false);
      });
  };
  // const ApprovalCollectionIndex = () => {
  //   const { searchTerm, setSearchTerm } = useContext(SearchContext);
  //   // ... rest of the code
  // };

  const finalList = [];
  list.forEach((item) => {
    if (item.approval_no.toString().indexOf(searchTerm) === -1) return;
    finalList.push(item);
  });

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  const handleSubmit = () => {
    postApi("update-approval", {
      query_type: "update_cheque",
      remarks: form.cheque,
      status: "Approval Processed",
      approval_no: approval,
      userId: user.username,
      mda_name: user ? user.mda_name : "",
      notif_key: "AG Approved Releases",
    })
      .then((resp) => {
        checkModalToggle();
        toast.success("Submitted");
        getApprovalCollection();
        setForm({});
      })
      .catch((err) => {
        toast.error("An error occured, please try again later");
        console.log(err);
      });
  };

  const totalReleases = selectedReleases.reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );
  // const qrCodeDataUri = qrCodeCanvas.toDataURL('image/jpg', 0.3)
  const [qrCodeDataUri, setQrCodeDataUrl] = useState("");

  useEffect(() => {
    QRCode.toDataURL("test").then((data) => {
      setQrCodeDataUrl(data);
    });
  }, []);
  const newDate = moment(form.date).format("DD/MM/YYYY");

  const total = budgetUtilization.reduce((a, b) => a + parseFloat(b.amount), 0);
  return (
    <>
      {pdf && isCheck ? (
        <>
          <Button
            className="btn-danger"
            onClick={() => {
              getApprovalCollection();
              setPdf(!pdf);
            }}
          >
            Close
          </Button>
          <PaymentSchedulePDF2
            tresuryDetails={form}
            newDate={newDate}
            form={{ ...form, total_amount: total }}
            paymentScheduleTable={budgetUtilization}
            qrImage={qrCodeDataUri}
          />
        </>
      ) : (
        <>
          {/* {JSON.stringify(isDirTreasury?"ag_approved_pvs":isExpControl?"exp_control_release":isCheck?"by_status":typeshit2?"payments":typeshit? "ag_pending_releases":"")}  */}
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            {/* {JSON.stringify(list)} */}
            {/* <Button
          onClick={() => history(Routes.approval.newApproval)}
          className="me-2 bg-success"
        >
          Add Approval
        </Button> */}
            <div className="d-block mb-4 mb-md-0">
              <h4>
                {/* <FontAwesomeIcon icon={faListUl} className="me-2" />  */}
                {isDirTreasury
                  ? "Director Treasury"
                  : isCheck
                  ? "Generate Check"
                  : isExpControl
                  ? "Expenditure Control"
                  : "AG Releases Dashboard"}
                <h5>{typeshit ? "Schedule" : "Payement"}</h5>
              </h4>
            </div>
            {/* {JSON.stringify(searchTerm)} */}
            <div className="btn-toolbar mb-2 mb-md-0">
              <ButtonGroup>
                <Button variant="outline-primary" size="sm">
                  Share
                </Button>
                <Button variant="outline-primary" size="sm">
                  Export
                </Button>
              </ButtonGroup>
            </div>
          </div>
          {/* {isDirTreasury? null :isCheck?null: 
        <ButtonGroup style={{ width: '100%' }}>
          <Button 
          onClick={() => setApprovalTypeFilter('Recurrent')} 
          variant={approvalTypeFilter === 'Recurrent' ? 'primary' : "outline-primary"}
          >
          Recurrent
          </Button>
          <Button 
          onClick={() => setApprovalTypeFilter('Capital')} 
          variant={approvalTypeFilter === 'Capital' ? 'primary' : "outline-primary"}
          >
          Capital
          </Button>
        </ButtonGroup>} */}
          {/* <SearchInput
        placeholder="Search For Releases"
        value={searchTerm}
        onChange={({ target: { value } }) => setSearchTerm(value)}
      /> */}

          <Row>
            <Col
              md={6}
              style={{
                marginTop: 28,
              }}
            >
              <SearchInput
                placeholder="Search For All Releases"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Row
                style={{
                  marginBottom: 10,
                }}
              >
                <Col md={6}>
                  <Form.Group id="date_from">
                    <Form.Label>Date From</Form.Label>
                    <Form.Control
                      type="date"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group id="date_to">
                    <Form.Label>Date to</Form.Label>
                    <Form.Control
                      type="date"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="d-flex justify-content-between">
            <h5>Total Selected: {selectedReleases.length}</h5>
            <h5>Total Amount : {formatNumber(totalReleases)}</h5>
          </div>

          {/* {JSON.stringify(finalList)} */}
          <Card
            border="light"
            className="table-wrapper table-responsive shadow-sm"
          >
            <Card.Body className="p-0">
              {loading ? (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div style={{ height: "80vh", overflow: "scroll" }}>
                  {/* {JSON.stringify(selectedReleases)} */}
                  {isDirTreasury ? (
                    <CustomTable
                      fields={fields2}
                      data={budgetUtilization}
                      // getRowStyle={(data) => getRowStyle(data)}
                    />
                  ) : isCheck ? (
                    <CustomTable
                      fields={fields2}
                      data={budgetUtilization}
                      // getRowStyle={(data) => getRowStyle(data)}
                    />
                  ) : isExpediture ? (
                    <CustomTable
                      fields={fields2}
                      data={budgetUtilization}
                      // getRowStyle={(data) => getRowStyle(data)}
                    />
                  ) : (
                    <CustomTable
                      fields={fields}
                      data={budgetUtilization}
                      // getRowStyle={(data) => getRowStyle(data)}
                    />
                  )}
                  {typeshit || isDirTreasury || isCheck ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        justifyContent: "center",
                      }}
                      className="mt-3"
                    >
                      <button
                        className="bg-danger"
                        style={{
                          border: "none",
                          color: "#fff",
                          height: "60%",
                          //   padding: 5,
                          paddingLeft: 10,
                          paddingRight: 10,
                          borderRadius: 10,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          toggleRemark();
                          toggleReturnModal();
                        }}
                      >
                        <FontAwesomeIcon icon={faReplyAll} className="me-1" />
                        Return
                      </button>
                      <button
                        className="bg-primary"
                        style={{
                          border: "none",
                          color: "#fff",
                          height: "60%",
                          //   padding: 5,
                          paddingLeft: 10,
                          paddingRight: 10,
                          borderRadius: 10,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (isCheck) {
                            checkModalToggle();
                          } else {
                            toggleRemark();
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faCheck} className="me-1" />
                        Approve
                      </button>
                    </div>
                  ) : typeshit2 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        justifyContent: "center",
                      }}
                      className="mt-3"
                    >
                      <CustomButton>
                        <img
                          src="https://asset.brandfetch.io/idxE04AMjS/idL34Q6qIN.png"
                          alt="interswitch_logo"
                          height={"30px"}
                          className="me-2"
                        />
                        Process Payments
                      </CustomButton>{" "}
                    </div>
                  ) : null}
                </div>
              )}
            </Card.Body>
            <Modal show={attachmentModalIsOpen} onHide={attachmentModalToggle}>
              <Modal.Header onHide={attachmentModalToggle}>
                Approval No.: {selectedApproval}
              </Modal.Header>
              <Modal.Body className="text-center">
                <Container>
                  <div className="image-container">
                    {/* {approvalImageInfo.length ? (
                  approvalImageInfo.map((item, index) =>
                    imageExtensions.some((extension) =>
                      item?.image_url?.toLowerCase()?.endsWith(extension)
                    ) ? (
                      <Card.Img
                        top
                        src={`${apiURL}/uploads/${item.image_url}`}
                        alt={"approval"}
                      />
                    ) : (
                      <Card.Body>
                        <Card.Link
                          href={`${apiURL}/uploads/${item.image_url}`}
                          target="_blank"
                        >
                          View PDF
                        </Card.Link>
                      </Card.Body>
                    )
                  )
                ) : (
                  <h4>No attachment found.</h4>
                )} */}
                  </div>
                </Container>
                {/* <h6>MDA: {approvalImageInfo.mda_name}</h6> */}
              </Modal.Body>
            </Modal>

            <Modal show={showRemark} size="lg" onHide={toggleRemark}>
              {approvalLoading ? null : (
                <Modal.Header onHide={toggleRemark}>Confirmation</Modal.Header>
              )}
              {approvalLoading ? (
                <span>
                  Please wait
                  <Spinner color="primary" size="xl" />
                </span>
              ) : approvalMessage && approvalMessage !== "" ? (
                <h5>{approvalMessage}</h5>
              ) : (
                <>
                  <Modal.Body className="text-center">
                    <CustomTable fields={modalFields} data={selectedReleases} />
                    <h5 style={{ float: "right" }}>
                      Total Amount : {formatNumber(totalReleases)}
                    </h5>
                  </Modal.Body>
                </>
              )}
              {approvalLoading ? null : (
                <Modal.Footer>
                  <div>
                    <Button
                      color="danger"
                      outline
                      className="m-1 p-1 px-3"
                      onClick={toggleRemark}
                    >
                      Cancel
                    </Button>
                    {returnModal ? (
                      <Button
                        className="m-1 p-1 px-3"
                        onClick={() =>
                          updateApproval(selectedApproval, "Return Processed")
                        }
                        loading={loading}
                      >
                        Return
                      </Button>
                    ) : (
                      <Button
                        className="m-1 p-1 px-3"
                        onClick={() =>
                          updateApproval(null, "Approval Processed")
                        }
                        loading={loading}
                      >
                        Approve
                      </Button>
                    )}
                  </div>
                </Modal.Footer>
              )}
            </Modal>

            <Modal show={showRemark1} onHide={toggleRemark1}>
              {returnlLoading ? null : (
                <Modal.Header onHide={toggleRemark1}>Confirmation</Modal.Header>
              )}
              {approvalLoading ? (
                <span>
                  Please wait
                  <Spinner color="primary" size="xl" />
                </span>
              ) : approvalMessage && approvalMessage !== "" ? (
                <h5>{approvalMessage}</h5>
              ) : (
                <>
                  <Modal.Body className="text-center">
                    <h5>
                      Are you sure you want to return this Release with No.:{" "}
                      {returndApproval}{" "}
                    </h5>

                    <div>
                      <h6>Add Remarks</h6>
                      <textarea
                        value={remark}
                        onChange={({ target: { value } }) =>
                          setShowRemark1(value)
                        }
                        className="form-control"
                        placeholder="Add Reason For Return"
                      />
                    </div>
                  </Modal.Body>
                </>
              )}
              {approvalLoading ? null : (
                <Modal.Footer>
                  <div>
                    <Button
                      outline
                      className="m-1 p-1 px-3"
                      color="danger"
                      onClick={toggleRemark1}
                    >
                      Cancel
                    </Button>
                    <Button
                      color="danger"
                      className="m-1 p-1 px-3"
                      onClick={
                        () =>
                          updateApproval(selectedApproval, "Return Processed")
                        // updateReturnApproval(returndApproval, "Return Processed")
                      }
                      loading={loading}
                    >
                      Return
                    </Button>
                  </div>
                </Modal.Footer>
              )}
            </Modal>

            <Modal show={check} onHide={checkModalToggle}>
              <Modal.Header onHide={checkModalToggle}>
                Enter Cheque Number
              </Modal.Header>
              <Modal.Body className="text-center">
                <Container>
                  {/* {JSON.stringify(approval)} */}
                  <Input
                    placeholder="Cheque Number"
                    name="cheque"
                    value={form.cheque}
                    // onChange={({ target: { value } }) => setForm({ ...form, cheque: value })}
                    onChange={handleChanges}
                  />
                </Container>
                {/* <h6>MDA: {approvalImageInfo.mda_name}</h6> */}
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <Button
                    color="danger"
                    className="m-1 p-1 px-3"
                    onClick={() => updateApproval(null, "Approval Processed")}
                    loading={loading}
                  >
                    Submit
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>

            <Modal show={_delete} onHide={toggleDelete}>
              <Modal.Header onHide={toggleDelete}>Delete</Modal.Header>
              <Modal.Body className="text-center">
                <h5>Are you sure you want to delete {item.approval_no} </h5>
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <Button
                    outline
                    className="m-1 p-1 px-3"
                    onClick={toggleDelete}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="danger"
                    className="m-1 p-1 px-3"
                    onClick={handleDelete}
                    loading={loading}
                  >
                    Delete
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          </Card>
        </>
      )}
    </>
  );
}

export default ApprovalCollectionAgDash;
